import { TokenManagerService } from 'src/app/core/services/token-manager.service';
import { User } from 'src/app/model/user.model';
import { AppConfiguration } from 'src/app/model/app-detail.model';

export class BaseComponent {
    CurrencySymbol: string;
    user: User;
    storeInfo: AppConfiguration;

    constructor(
        public tokenManagerService: TokenManagerService
    ) {
        this.CurrencySymbol = tokenManagerService.appConfiguration.CurrencySymbol;
        this.user = this.tokenManagerService.userDetail;
        this.storeInfo = this.tokenManagerService.appConfiguration;
    }
}
